import React from 'react';
import memojiImage from '../assets/memoji-computer.png';
import grainImage from '../assets/grain.jpg';
import { ReactComponent as StarIcon } from '../assets/star.svg';
import { ReactComponent as SparkelIcon } from '../assets/sparkle.svg';
import { HeroOrbit } from './HeroOrbit';
import { MouseIcon } from 'lucide-react';

export const HeroSection = () => (
  <div
    className='py-32 md:py-48 lg:py-60 relative z-0 overflow-x-clip'
    id='home'
  >
    <div className='absolute inset-0 [mask-image:linear-gradient(to_bottom,transparent,black_10%,black_70%,transparent)]'>
      <div
        className='absolute inset-0 -z-30 opacity-5'
        style={{
          backgroundImage: `url(${grainImage})`,
        }}
      ></div>
      <div className='size-[620px] hero-ring'></div>
      <div className='size-[820px] hero-ring'></div>
      <div className='size-[1020px] hero-ring'></div>
      <div className='size-[1220px] hero-ring'></div>

      <HeroOrbit
        size={430}
        rotation={-14}
        shouldOrbit
        orbitDuration='30s'
        shouldSpin
        spinDuration='3s'
      >
        <SparkelIcon className='size-8 text-emerald-300/20' />
      </HeroOrbit>
      <HeroOrbit
        size={440}
        rotation={79}
        shouldOrbit
        orbitDuration='32s'
        shouldSpin
        spinDuration='3s'
      >
        <SparkelIcon className='size-5 text-emerald-300/20' />
      </HeroOrbit>
      <HeroOrbit size={520} rotation={-41} shouldOrbit orbitDuration='34s'>
        <div className='size-2  rounded-full text-emerald-300/20' />
      </HeroOrbit>
      <HeroOrbit
        size={530}
        rotation={178}
        shouldOrbit
        orbitDuration='36s'
        shouldSpin
        spinDuration='3s'
      >
        <SparkelIcon className='size-10 text-emerald-300/20' />
      </HeroOrbit>
      <HeroOrbit
        size={550}
        rotation={20}
        shouldOrbit
        orbitDuration='38s'
        shouldSpin
        spinDuration='6s'
      >
        <StarIcon className='size-12 text-emerald-300' />
      </HeroOrbit>
      <HeroOrbit
        size={590}
        rotation={98}
        shouldOrbit
        orbitDuration='40s'
        shouldSpin
        spinDuration='6s'
      >
        <StarIcon className='size-8 text-emerald-300' />
      </HeroOrbit>
      <HeroOrbit size={650} rotation={-5} shouldOrbit orbitDuration='42s'>
        <div className='size-2  rounded-full text-emerald-300/20' />
      </HeroOrbit>
      <HeroOrbit
        size={710}
        rotation={144}
        shouldOrbit
        orbitDuration='44s'
        shouldSpin
        spinDuration='3s'
      >
        <SparkelIcon className='size-10 text-emerald-300/20' />
      </HeroOrbit>
      <HeroOrbit size={720} rotation={85} shouldOrbit orbitDuration='46s'>
        <div className='size-3 rounded-full text-emerald-300/20' />
      </HeroOrbit>
      <HeroOrbit
        size={800}
        rotation={-74}
        shouldOrbit
        orbitDuration='48s'
        shouldSpin
        spinDuration='6s'
      >
        <StarIcon className='size-28 text-emerald-300' />
      </HeroOrbit>
    </div>

    <div className='container'>
      <div className='flex flex-col items-center'>
        <img
          src={memojiImage}
          className='size-[100px]'
          alt='Person peeking from behind the laptop'
        />
        <div className='bg-gray-950 border border-gray-800 px-4 py-1.5 inline-flex items-center gap-4 rounded-lg'>
          <div className='bg-green-500 size-2.5 rounded-full relative'>
            <div className='bg-green-500 absolute inset-0 rounded-full animate-ping-large'></div>
          </div>
          <div className='text-sm font-medium'>Tech Devotee</div>
        </div>
      </div>
      <div></div>
      <div className='max-w-lg mx-auto'>
        <h1 className='font-serif text-3xl md:text-5xl text-center mt-8 tracking-wide'>
          Hi there! I'm Suraj
        </h1>
        <p className=' mt-4 text-center text-white/60 md:text-lg'>
          Passionate Full Stack Developer adept at crafting innovative
          solutions. Enjoys building projects from conception to implementation.
        </p>
      </div>
    </div>
    <div className=' opacity-60 mt-12 justify-center flex items-center flex-col'>
      <MouseIcon size={40} className=' animate-bounce' />
      <span className=' text-sm font-medium'>Scroll Down</span>
    </div>
  </div>
);
